import { render } from "./dispatch-header.vue?vue&type=template&id=0609a9e5&ts=true"
import script from "./dispatch-header.ts?vue&type=script&lang=ts"
export * from "./dispatch-header.ts?vue&type=script&lang=ts"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__